export default __webpack_public_path__ + "static/sun-89595b6ef21fbdd7afc1fb0cc7f9426d.svg";